<template>
  <div class="SymbolTableComponent dataTables">

        <div v-show="isData" :id="id"></div>

        <LoaderComponent  v-show="!isData"></LoaderComponent>

    </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import LibraryTypes from '@/constants/LibraryTypes'
  import { mapGetters } from 'vuex'

    import $ from 'jquery';
    import dt from 'datatables.net-bs4';
    
    
    export default {
        name: "SymbolTableComponent",
        props:{
          lang: Object,
          reloadTable: Boolean,
          data: Object
        },
        components: {
         
          LoaderComponent
        },
        data () {
            return {
                name: "SymbolTableComponent",
                mainTable: "",
                symbols: [],
                isData: false,
                searchTableInput: ""
            }
        },
        computed: {
          ...mapGetters({
            
            appConf: 'appConf'

          }),
          id () {

            return "place_" + this._uid
          },
          
          filteredData(){
            // var a = this.mainTable
            // .column( 4 )
            // .data()
            // .filter( function ( value, index ) {
            //   console.log(value)
            //   console.log(index)
            //     return value > 20 ? true : false;
            // } );

            // return a
          },
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          }
        },
        created () {
          

          this.getSymbols()

          
        },
        watch: {
          reloadTable: function () {
            
            this.getSymbols();
          }
        },
        updated() {
          
          
        },
        methods: {
          async loadSVG(blob, id){

            let svgData = await new Response(blob).text();
            
            let place = document.getElementById(id);
            if (place != null){
              place.innerHTML = "";

            var parser = new DOMParser();
            var doc = parser.parseFromString(svgData, "image/svg+xml");
            doc.documentElement.setAttribute("width", 40);
            doc.documentElement.setAttribute("height", 40);
                  
            place.appendChild(doc.documentElement);
            
            
            
            }
            
          },
          add(item){
            

          },
          getSymbols(){
            let vue = this;
            this.isData = false;

            let action = '_getSymbols';
            if (this.data.type == LibraryTypes.HDLSYMBOL) {
              action = '_getHDLSymbols';
            }
            
            this.$store.dispatch(this.$store.getters.sectionPrefix + action)
            .then((result) => {
              console.log(result)
              if (result.status == "OK"){
                vue.isData = true;
                vue.symbols = result.data;
                
                vue.buildTable();
              }

            })
          },
          buildTable(){
          


          let tableplace = document.getElementById(this.id);
          if (tableplace == null){
            return
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          let table = document.createElement("table");
          table.setAttribute("id", "t_"+this.id);
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          let tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          let thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          let _vue = this;

          let columns = [
            {
              name: "Id",
              alignInColumn: "left",

            },
            // {
            //   name: this.lang.table_header_Image,
            //   alignInColumn: "left",

            // },
            {
              name: this.lang.table_header_Name,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Status,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Action,
              alignInColumn: "left",

            },
            

          ]

          let cols =  [
            //{ "data": "symbolId" },
            { "data": "symbolId" },
            { "data": "name" },
            { "data": "prototype" },
            

          ]


          let columnDefs = [];
          let len = columns.length;
          for (let i = 0; i < len; i++){
            let widthCol = "";
            if (i == 0){
              widthCol = "20%"
            }
            if (i == 1){
              widthCol = "300px"
            }
            if (i == 2){
              widthCol = "20%"
            }
            if (i == 3){
              widthCol = "10%"
            }

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            const el = {
              targets: i,
              width: widthCol,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }


                if(meta.col == 0){

                  return  data;

                }
                // if (meta.col == 1){
                //   let id = "symbol__"+data;
                                        
                //     let image = "<div id=\""+id+"\" data-revisionid=\""+data+"\" data-name=\""+row.name+"\" data-type=\"symbol\" class=\"image-library\"></div>";


                //     const obj = {
                //       type: "symbol",
                //       name: row.name,
                //       id: id,
                //       revisionId: data
                //     }
                    
                //     if (data != ""){
                      
                //         _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_getSvg", obj)
                //         .then((result) => {
                          
                //           if (result != null){
                            
                            
                //             let id = result.id;                          
                //             _vue.loadSVG(result, id);
                            
                            
                //           }
                        
                //         })
                      
                //     }else{
                //       image = data.display;
                //     }
                                            
                //     return image;
                // }
                if (meta.col == 1){


                  return data;
                }
                if (meta.col == 2){

                  if (data == true){
                    return "<b-badge class='badge badge-warning '>"+_vue.lang.tag_Prototype+"</b-badge>";
                  }
                  return "";
                }
                if (meta.col == 3) {
                  let str = "<button  class=\"btn btn-secondary btn-sm btn-"+_vue.variant+" button-action-add\" id=\"button_add__" + row.symbolId +"\" >"+_vue.lang.button_Add+"</button>";
                  if (!_vue.appConf.status.isLM){
                      str += "<button  class=\"btn btn-secondary btn-sm btn-"+_vue.variant+" button-action-delete\" id=\"button_delete__" + row.symbolId +"\" >"+_vue.lang.button_Delete+"</button>";
                  }
                  if (_vue.data.type == LibraryTypes.HDLSYMBOL) {
                    // str = "<button  class=\"btn btn-secondary btn-sm btn-" + _vue.variant + " button-action-select\" id=\"button_select__" + row.symbolId + "\" >" + _vue.lang.button_Select + "</button>";
                    
                  }
                      
                    
                  return str;
                }
                

              },
              

            }

            columnDefs.push(el);

            

            let th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);
            // let p = document.createElement("p");
            // th.appendChild(p);
            

            let tx = document.createTextNode(columns[i].name)
            th.appendChild(tx);

          }


          const json = {};
          json.paging = true;
          json.info = true;
          json.dom = 'f<t>ip';
          json.data= this.symbols;
          json.myColumnFormats = columns;
          json.select = false;
          json.order = [[1, "asc"]];
          json.lengthMenu = [8];
          json.columns = cols;

          json.columnDefs = columnDefs;
          json.initComplete = function () {
            
            
            
          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }

          

          this.mainTable = $('#t_'+this.id).DataTable(json);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
  

          $("#t_"+this.id + ' tbody').on( 'click', 'button', function (e) {
            
            

              var data = _vue.mainTable.row( $(this).parents('tr') ).data();
              

              let posSelect = e.target.id.indexOf("add");
            
              if (posSelect > -1){
                for (let i = 0, lei = _vue.symbols.length; i < lei; i++){
                  if (_vue.symbols[i].symbolId == data.symbolId){

                    _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_addSelectedSymbol", _vue.symbols[i]);
                    break;
                  }
                }
            }
            posSelect = e.target.id.indexOf("select");
            
            if (posSelect > -1) {
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteAllSelectedSymbols");
              for (let i = 0, lei = _vue.symbols.length; i < lei; i++) {
                if (_vue.symbols[i].symbolId == data.symbolId) {

                  _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_addSelectedSymbol", _vue.symbols[i]);
                  break;
                }
              }
            }
              let posDelete = e.target.id.indexOf("delete")
              if (posDelete > -1){
                
                const obj = {
                  symbolId: data.symbolId
                }

                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSymbol", obj)
                .then((result) => {

                  console.log(result)
                  if (result.status == "OK"){

                    _vue.getSymbols()
                  }
                })
                  
                
              }
              
          });

          this.mainTable.draw();

        }
          
        }


    }
</script>
<style lang="scss">
  // @import "./../../scss/_theme.scss";
  // @import "./../../scss/_tables.scss";
  
  .SymbolTableComponent {
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      width: 100% !important;
      margin-right: 10px;
      
    }
    table th {
      padding: 2px !important;
      min-width: 200px;
    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    table {
      .btn {
        padding: 0.15rem 0.5rem;
        margin: 2px;
      }
      .image-library{
        max-width: 40px;
        border-radius: 2px;
        margin-top: 3px;
        margin-right: 3px;
        margin-bottom: 3px;
        background-color: white;
        padding: 2px;
      }
      .badge{
        margin: 3px;
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/shared/SymbolTableComponent.vue